module.exports = __webpack_public_path__ + "img/agrinos.f5debfed.png";